module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"paymentMethod":"Payment method","automaticCalculation":"Calculation","F":"Invoice","A":"Settlement","DefaultPriceCode":"Default pricecode","title":"Economical"},"no":{"paymentMethod":"Opppgjørsform","automaticCalculation":"Beregning","F":"Faktura","A":"Avregning","DefaultPriceCode":"Standard priskode","title":"Økonomisk"}}')
  delete Component.options._Ctor
}
